// extracted by mini-css-extract-plugin
export default {"largeWidth":"a1ef1bdef7ffe948d0f5c23fa7e45500","fixed":"_3519ba37a4bd6c4050793210c6c9141c","itemLink":"_0052c789f09ce94989da9b0c303e6b7c"};